import usePrivacyStatement from "../hooks/usePrivacyStatement";

/**
 * Renders a "Privacy Statement" link that opens the PDF in a new tab.
 * Renders nothing if the document hasn't been uploaded yet.
 * Accepts an optional `className` for styling.
 */
const PrivacyStatementLink = ({ className = "" }) => {
  const { url } = usePrivacyStatement();
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      Privacy Statement
    </a>
  );
};

export default PrivacyStatementLink;
